import * as React from "react";
import {
  CardDescription,
  UsernameCardWrapper,
} from "src/components/shared/Cards/Cards.components";
import { UserCardElement } from "src/components/shared/Cards/UserCard/UserCard.components";
interface Props {
  username: string;
  value?: string;
  voteReveal?: boolean;
  picked: boolean;
  lowestScore?: boolean;
  highestScore?: boolean;
}

const UserCard: React.FunctionComponent<Props> = ({
  username,
  voteReveal = false,
  value,
  picked,
  lowestScore,
  highestScore
}) => {
  return (
    <UsernameCardWrapper>
      <UserCardElement
        lowestScore={lowestScore}
        highestScore={highestScore}
        data-cy={picked ? "selectedCard" : "userCard"}
        picked={picked}
        turned={!!value && voteReveal}>
        {voteReveal && value}
      </UserCardElement>
      <CardDescription>
        {username}
      </CardDescription>
    </UsernameCardWrapper>
  );
};

export default UserCard;
